import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { urls } from '@gift/common/_urls';
import fetch from 'cross-fetch';

type Collection = {
    url: string;
    type: string;
    contentType: string;
}

type LoadCollectionResult = {
    entries: Collection[];
};

export const publicAssets = createApi({

    baseQuery: fetchBaseQuery({
        fetchFn: (r: RequestInfo) => {
            return typeof r === 'string' ? fetch(r) : fetch(r.url, r);
        }
    }),

    endpoints: build => ({

        getCollectionUrls: build.query<string[], string>({
            query: id => ({ url: urls.loadCollection(id) }),
            transformResponse: (response: LoadCollectionResult) =>
                response.entries.map(e => e.url)
        })
    })
});
